import React from 'react';
import PropTypes from 'prop-types';
import { SearchableSelectField } from 'common/form/SearchableSelectField';
import { SelectField } from 'common/form/SelectField';
import { Icon } from '@unite-us/ui';
import { SearchableField } from 'common/form/SearchableField';

const FilterSelectors = ({
  filterValues,
  filterOptions,
  onUpdateFilter,
  setRequestTypeFilter,
  setSccPlanFilter,
  setOpenAllFiltersDrawer,
  setClientNameFilter,
}) => (
  <div className="flex items-start items-center space-x-4">
    <SelectField
      className="w-64"
      label="Request Type"
      placeholder="Choose Type"
      options={filterOptions.requestType}
      value={filterValues.requestType ?? ''}
      onChange={({ value }) => {
          setRequestTypeFilter(value);
          onUpdateFilter();
        }}
      clearable
    />
    <SearchableField
      className="w-64"
      label="Client Name"
      placeholder="Search for a client"
      onChange={({ value }) => {
          setClientNameFilter(value);
        }}
      searchQuery={filterValues.clientName ?? ''}
      onInputChange={setClientNameFilter}
      clearable
    />
    <SearchableSelectField
      className="w-100"
      label="Social Care Coverage Plan"
      placeholder="Choose Plan"
      value={filterValues.sccPlan ?? ''}
      onChange={({ value }) => {
          setSccPlanFilter(value);
          onUpdateFilter();
        }}
      options={filterOptions.sccPlan}
      truncateOptions={false}
      clearable
    />
    <button
      type="button"
      aria-label="All Filters"
      className="min-w-max pt-8 md:pt-6 lg:pt-6 lg:max-xlg:6 xl:pt-8 "
      onClick={() => setOpenAllFiltersDrawer(true)}
    >
      <Icon
        icon="IconFilter"
        ariaLabel="All Filters"
        color="#2C405A"
      />
      <span className="ml-1">All Filters</span>
    </button>
  </div>
);

FilterSelectors.propTypes = {
  filterValues: PropTypes.shape({
    requestType: PropTypes.string,
    sccPlan: PropTypes.string,
    clientName: PropTypes.string,
  }).isRequired,
  filterOptions: PropTypes.shape({
    requestType: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })).isRequired,
    sccPlan: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })).isRequired,
  }).isRequired,
  onUpdateFilter: PropTypes.func.isRequired,
  setRequestTypeFilter: PropTypes.func.isRequired,
  setSccPlanFilter: PropTypes.func.isRequired,
  setOpenAllFiltersDrawer: PropTypes.func.isRequired,
  setClientNameFilter: PropTypes.func.isRequired,
};

export default FilterSelectors;
